module.exports = "<p>\n  index works!\n</p>\n"